import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { ExtendedAccountResponse } from '../store/types';
import { Navigate } from 'react-router-dom';

export const SuperAdminDomainProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const auth = useSelector((state: RootState) => state.auth);
  const account = auth.account as ExtendedAccountResponse | null;
  const userRole = (account?.user?.role || account?.role)?.trim().toLowerCase();
  const email = account?.user?.email || account?.email;
  const emailDomain = email?.split('@')[1]?.toLowerCase();

  if (userRole !== 'superadmin' || emailDomain !== 'vaultiscan.ai') {
    // You can redirect or render a "Not Authorized" component here
    return <Navigate to="/login" replace />;
  }
  return children;
};
